import { useState, useMemo, createContext } from "react";
import { COMPLIANCE_YEARS } from "../settings";

const initialFieldData = {
  areas: {
    zone: [],
    la: [],
  },
  pollutant_metric_list: {
    zone: [],
    la: [],
  },
  year: COMPLIANCE_YEARS,
  query_layers: [
    { name: "Zone", id: "zone" },
    { name: "Local Authority", id: "la" },
  ],
};

export const FieldStateDataContext = createContext();

export const FieldDataProvider = ({ children }) => {
  const [fieldDataState, setFieldDataState] = useState(initialFieldData);
  const values = useMemo(
    () => [fieldDataState, setFieldDataState],
    [fieldDataState]
  );
  return (
    <FieldStateDataContext.Provider value={values}>
      {children}
    </FieldStateDataContext.Provider>
  );
};
